import React, { Component } from "react";
import PropTypes from "prop-types";

export default class RadioGroup extends Component {
  getChildContext() {
    const { name, selectedValue, disabled, onChange, type } = this.props;
    return {
      radioGroup: {
        name,
        selectedValue,
        disabled,
        onChange,
        type,
      },
    };
  }

  render() {
    const { BaseComponent, name, selectedValue, disabled, onChange, children, label, ...rest } = this.props;
    return (
      <BaseComponent role="radiogroup" label={label} {...rest}>
        {children}
      </BaseComponent>
    );
  }
}

RadioGroup.defaultProps = {
  name: null,
  selectedValue: null,
  onChange: null,
  BaseComponent: "div",
  type: "radio",
};

RadioGroup.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  BaseComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({})]),
};

RadioGroup.childContextTypes = {
  radioGroup: PropTypes.shape({}),
};
